module.exports = __webpack_public_path__ + "img/p2-42.0488385b.png";